import type {
  PageSetupInstanceProps,
  ProductSidebarProps,
} from '@zoomcatalog/design-templates';

export const pageSetupLocale: PageSetupInstanceProps['options']['locale'] = {
  UPLOAD: 'Upload',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  SEARCH: 'Search',
  BY: 'By',
  ADD_IMAGE: 'Add image',
  ADD_COVER_DESCRIPTION: 'Add a cover image to your page',
  ADD_PRODUCT: 'Add a product',
  ADD_AN_IMAGE: 'Add an image',
  REPLACE_PRODUCT: 'Replace product',
  REMOVE_PRODUCT: 'Remove product',
  SELECT_PRODUCT_SLOT: 'Select the product you want to display in this slot',
  RESULTS_MESSAGE(amount: number, keyword: string) {
    return `${amount} results for "${keyword}"`;
  },
  NO_RESULTS: 'No results found',
  TRY_SOMETHING_DIFFERENT:
    'We could find no images matching your search. Try something different',
  DELETE_PRODUCT_CONFIRMATION: 'Are you sure you want to remove this product?',
  DELETE_LOGO_CONFIRMATION: 'Are you sure you want to remove this logo?',
  DONE: 'Done',
  DRAG_IMAGE_TO_REPOSITION: 'Drag image to reposition',
  REMOVE_IMAGE: 'Remove image',
  REPOSITION_IMAGE: 'Reposition image',
  COVER_MODE: 'Cover mode',
  CONTAIN_MODE: 'Contain mode',
  VIEW_ALL_INFO: 'View all info',
  VIEW_PRODUCT: 'View product',
  SELECT_PRODUCT: 'Select product',
  COLORS: 'Colors',
  SIZES: 'Sizes',
  DESCRIPTION: 'Description',
  MORE_COLORS: 'More colors',
  PRICE_FROM: 'Price from:',
  CALL_FOR_PRICING: 'Call for pricing',
  EDIT_VIRTUAL_SAMPLE: 'Edit virtual sample',
  REMOVE_VIRTUAL_SAMPLE: 'Remove virtual sample',
  REPOSITION_LOGO: 'Reposition logo',
  EDIT_LOGO: 'Edit logo',
};

export const productSidebarLocale: ReturnType<
  ProductSidebarProps['getters']['getLocaleTranslations']
> = {
  PRODUCT_INFO: 'Product Information',
  COLORS: 'Color Swatches',
  SIZES: 'Sizes',
  MATERIALS: 'Materials',
  PRICING: 'Pricing',
  MOQ: 'Minimum order quantity',
  AS_LOW_AS: (priceCode: string, price: string) =>
    `${priceCode ? `(${priceCode})` : ''} As low as ${price}`,
  STARTING_AT: (priceCode: string, price: string) =>
    `${priceCode ? `(${priceCode})` : ''} Starting at ${price}`,
  MSRP: (priceCode: string, price: string) =>
    `${priceCode ? `(${priceCode})` : ''} MSRP ${price}`,
  NO_LABEL: (priceCode: string, price: string) =>
    `${priceCode ? `(${priceCode})` : ''} ${price}`,
  READ_FULL_DESCRIPTION: 'Read full description',
  DOWNLOAD: 'Download',
  NO_IMAGE_AVAILABLE: 'No image available',
  VIEW_ON_OUR_WEBSITE: 'View on our website',
};
